import * as React from 'react';
import * as colors from 'style/color';
import {ReactComponent as Logo} from 'assets/company_logo.svg';
import {Menu, MenuList, MenuButton, MenuItem} from '@reach/menu-button';

type HeaderProps = {
  username: string;
  onLogout: () => void;
};
function Header({username, onLogout}: HeaderProps) {
  return (
    <header
      className={
        'px-4 bg-brand-black h-[52px] flex items-center justify-between shrink-0'
      }
    >
      <Logo />
      <Menu id={'user-info'}>
        <MenuButton>Hi, {username}</MenuButton>
        <MenuList>
          <MenuItem onSelect={() => onLogout()}>登出</MenuItem>
        </MenuList>
      </Menu>
    </header>
  );
}

export default Header;
